import { Controller } from '@hotwired/stimulus';
import { Turbo } from '@hotwired/turbo-rails';

export default class extends Controller {
  connect() {
    this.onchangeUrl = this.element.dataset.onchangeUrl;
    this.element.addEventListener('change', this.switchToggled.bind(this));
  }

  switchToggled() {
    if (this.onchangeUrl) {
      Turbo.visit(this.onchangeUrl);
    }
  }
}
